export default function sortByMomentDates(order, field) {
  return (a, b) => {
    const sortResult = a[field].isBefore(b[field]) ? -1 : 1;

    if (order === 'asc') {
      return sortResult;
    }

    return -sortResult;
  };
}
